<template>
  <div v-if="$route.params.page == 5" class="hoverTooltip">
      <i
    v-if="option === 'Inkjet'"
      class="material-icons md-36"
      v-b-tooltip.html
      :title="tooltipInkjet"
    >help</i>
    <i
    v-if="option === 'Laser'"
      class="material-icons md-36"
      v-b-tooltip.html
      :title="tooltipLaser"
    >help</i>
  </div>
</template>

<style scoped>
.hoverTooltip {
  position: absolute;
  top: 28px;
  right: 36px;
}

@media (min-width: 1200px) {
  .hoverTooltip {
    right:66px;
  }
 }
</style>

<script>
export default {
  name: 'tooltip',
  props: {
    option: String
  },
  data() {
    return {
      tooltipInkjet: `<p>Inkjet: Cost effective printing, ideal for light home, home office and photo printing</p>`,
      tooltipLaser: `<p>Laser: High capacity printing, ideal for home office and business printing, fast print speeds, print sharp text and images</p>`
    };
  }
};
</script>
